import { isPayment } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers/index.js';
import { InterestFrom, } from '@debbie/common/dist/voucher-applications/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { toPercent } from '../../utils/index.js';
import { RadioSelect } from '../index.js';
import Input from '../Input.js';
const VoucherCustomizer = (props) => {
    const filter = props.filter || ((c) => true);
    const lang = useSelector((s) => s.lang);
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : null;
    const [days, setDays] = useState(30);
    const [interestRate, setInterestRate] = useState(0.07);
    const [interestFrom, setInterestFrom] = useState(InterestFrom.Date);
    const [amount, setAmount] = useState(10000);
    const isPaymentTypeId = (voucherTypeId) => {
        const voucherType = voucherTypes?.find((vT) => vT.voucherTypeId === voucherTypeId);
        return voucherType != null && isPayment(voucherType);
    };
    const voucherOptions = (voucherType) => voucherType === VoucherTypeIds.PROCESSINTEREST ||
        voucherType === VoucherTypeIds.GLPROCESSINTEREST
        ? { days, from: interestFrom }
        : voucherType === VoucherTypeIds.YEARLYINTEREST
            ? { days, interestRate, from: interestFrom }
            : voucherType === VoucherTypeIds.FIXEDINTEREST
                ? { days, from: interestFrom, amount }
                : isPaymentTypeId(voucherType)
                    ? { amount: -amount }
                    : { amount };
    useEffect(() => {
        props.onChange(props.voucherType, voucherOptions(props.voucherType));
    }, [days, interestFrom, interestRate, amount, voucherTypes]);
    return (React.createElement(Wrapper, { style: props.style },
        React.createElement(Selector, null, voucherTypes &&
            voucherTypes
                .filter((voucherType) => [
                VoucherCategory.PRINCIPAL,
                VoucherCategory.COST,
                VoucherCategory.COURTCOST,
                VoucherCategory.INTEREST,
                VoucherCategory.TRANSACTION,
            ].includes(voucherType.category))
                .filter((vT) => filter(vT.voucherTypeId))
                .map((vT) => {
                return (React.createElement(SelectorItem, { key: vT.voucherTypeId, selected: vT.voucherTypeId === props.voucherType, onClick: () => {
                        props.onChange(vT.voucherTypeId, voucherOptions(vT.voucherTypeId));
                    } }, lang.economyVoucherTypeLabels[vT.voucherTypeId]));
            })),
        React.createElement(Customizer, null,
            [VoucherTypeIds.YEARLYINTEREST].includes(props.voucherType) ? (React.createElement(Input, { placeholder: lang.economy.interestRate, type: "number", value: toPercent(interestRate), onChange: (e) => {
                    setInterestRate(parseFloat(e.target.value) / 100);
                } })) : null,
            ![
                VoucherTypeIds.GLPROCESSINTEREST,
                VoucherTypeIds.PROCESSINTEREST,
                VoucherTypeIds.YEARLYINTEREST,
            ].includes(props.voucherType) ? (React.createElement(Input, { placeholder: lang.economy.amount, type: "number", value: amount / 100, onChange: (e) => {
                    setAmount(parseInt(e.target.value) * 100);
                } })) : null,
            [
                VoucherTypeIds.GLPROCESSINTEREST,
                VoucherTypeIds.PROCESSINTEREST,
                VoucherTypeIds.YEARLYINTEREST,
                VoucherTypeIds.FIXEDINTEREST,
            ].includes(props.voucherType) ? (React.createElement(React.Fragment, null,
                React.createElement(Input, { placeholder: lang.economy.interestStartDays, type: "number", value: days, onChange: (e) => {
                        setDays(parseInt(e.target.value));
                    } }),
                React.createElement(FromSelect, null, Object.values(InterestFrom).map((from) => {
                    return (React.createElement(RadioSelect, { key: from, active: interestFrom === from, label: lang.interestFromLabels[from], onClick: () => setInterestFrom(from) }));
                })))) : null)));
};
const Wrapper = styled.div `
  border-top: 1px solid ${THEME.BORDER_STRONG};
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
  max-height: 200px;
  display: flex;
  box-shadow:
    inset 0em 2px 2px rgba(0, 0, 0, 0.1),
    inset 0em -2px 2px rgba(0, 0, 0, 0.1);
`;
const Selector = styled.div `
  width: 40%;
  max-width: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid ${THEME.BORDER_STRONG};
`;
const SelectorItem = styled.div `
  width: 100%;
  padding: 0.5rem;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  border-bottom: 1px solid ${THEME.BORDER};
  background-color: ${(p) => (p.selected ? THEME.FILL : 'transparent')};

  &:hover {
    background-color: ${(p) => (p.selected ? THEME.FILL : THEME.FILL)};
  }
`;
const Customizer = styled.div `
  flex-grow: 1;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
`;
const FromSelect = styled.div `
  display: flex;
  margin-bottom: 20px;
`;
export default VoucherCustomizer;
//# sourceMappingURL=VoucherCustomizer.js.map